import { createSlice } from "@reduxjs/toolkit";
import { fetchCarousels } from "./carouselBaseApi";
const carouselsSlice = createSlice({
    name: "carousels",
    initialState: {
      carousels: [],
      status: "idle",
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchCarousels.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchCarousels.fulfilled, (state, action) => {
          state.status = "succeeded";
          state.carousels = action.payload;
        })
        .addCase(fetchCarousels.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.error.message;
        })
    },
  });
  
  export default carouselsSlice.reducer;